import { render, staticRenderFns } from "./SmileySelection.vue?vue&type=template&id=19d03765&"
import script from "./SmileySelection.vue?vue&type=script&lang=js&"
export * from "./SmileySelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports